import type {
  AnonymousEcc,
  AnonymousFormat,
  AnonymousFrame,
  AnonymousWifiAuth,
} from "@qrody/api-client/render";

export const PAYLOAD_TYPES = [
  "url",
  "text",
  "email",
  "sms",
  "geo",
  "wifi",
  "vcard",
  "file",
] as const;

export type PayloadType = (typeof PAYLOAD_TYPES)[number];

export function isPayloadType(value: unknown): value is PayloadType {
  return typeof value === "string" && (PAYLOAD_TYPES as readonly string[]).includes(value);
}

export interface QrGeneratorFormState {
  url: string;
  text: string;
  emailTo: string;
  emailSubject: string;
  emailBody: string;
  smsTo: string;
  smsMessage: string;
  geoLat: string;
  geoLon: string;
  wifiSsid: string;
  wifiPassword: string;
  wifiAuth: AnonymousWifiAuth;
  wifiHidden: boolean;
  vcardFullName: string;
  vcardEmail: string;
  vcardPhone: string;
  vcardOrg: string;
  vcardTitle: string;
  vcardUrl: string;
  fileUrl: string;
}

export const INITIAL_FORM: QrGeneratorFormState = {
  url: "https://qrody.com",
  text: "Hello, qrody!",
  emailTo: "",
  emailSubject: "",
  emailBody: "",
  smsTo: "",
  smsMessage: "",
  geoLat: "52.5200",
  geoLon: "13.4050",
  wifiSsid: "",
  wifiPassword: "",
  wifiAuth: "WPA",
  wifiHidden: false,
  vcardFullName: "",
  vcardEmail: "",
  vcardPhone: "",
  vcardOrg: "",
  vcardTitle: "",
  vcardUrl: "",
  fileUrl: "",
};

export interface QrGeneratorSeed {
  type: PayloadType;
  form?: Partial<QrGeneratorFormState>;
  foreground?: string;
  background?: string;
  frame?: AnonymousFrame;
  ecc?: AnonymousEcc;
  minVersion?: number | null;
  /** Initial default download format the editor should restore. */
  format?: AnonymousFormat;
  /** Initial raster pixel side-length the editor should restore. */
  size?: number;
}
